module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-1022w.8ac65198.webp";